import { render, staticRenderFns } from "./RecaptchaCheckbox.vue?vue&type=template&id=9ba68ab2"
import script from "./RecaptchaCheckbox.vue?vue&type=script&lang=js"
export * from "./RecaptchaCheckbox.vue?vue&type=script&lang=js"
import style0 from "./RecaptchaCheckbox.vue?vue&type=style&index=0&id=9ba68ab2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_40df3e800382af9a7a59c1fe33ba5098/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports